export default "__VITE_ASSET__B4W9H1oI__"